(function () {
  'use strict';

  if (window.MCubeCore) return;

  var FALLBACK_STORAGE_KEYS = {
    wishlist: 'mcube_wishlist_v2',
    projects: 'mcube_projects_v2'
  };

  var LEGACY_STORAGE_KEYS = {
    wishlist: 'mcube_wishlist_v1',
    projects: 'mcube_projects_v1'
  };
  var accountSyncConfig = window.MCubeAccountSyncConfig || {};
  var accountCustomerId = toStringValue(accountSyncConfig.customerId).replace(/[^a-zA-Z0-9_-]/g, '');
  var accountSyncActive = accountSyncConfig.enabled === true && Boolean(accountCustomerId);
  var STORAGE_VERSION = accountSyncActive ? 3 : 2;
  var STORAGE_KEYS = accountSyncActive
    ? {
        wishlist: 'mcube_wishlist_v3_customer_' + accountCustomerId,
        projects: 'mcube_projects_v3_customer_' + accountCustomerId
      }
    : FALLBACK_STORAGE_KEYS;
  var memoryStorage = {};

  function clone(value) {
    if (value === undefined || value === null) return value;
    return JSON.parse(JSON.stringify(value));
  }

  function now() {
    return Date.now();
  }

  function hasLocalStorage() {
    try {
      var key = '__mcube_test__';
      window.localStorage.setItem(key, '1');
      window.localStorage.removeItem(key);
      return true;
    } catch (error) {
      return false;
    }
  }

  var localStorageAvailable = hasLocalStorage();

  function getStorageItem(key) {
    if (localStorageAvailable) {
      try {
        return window.localStorage.getItem(key);
      } catch (error) {
        return memoryStorage[key] || null;
      }
    }

    return memoryStorage[key] || null;
  }

  function setStorageItem(key, value) {
    if (localStorageAvailable) {
      try {
        window.localStorage.setItem(key, value);
        return;
      } catch (error) {
        memoryStorage[key] = value;
        return;
      }
    }

    memoryStorage[key] = value;
  }

  function removeStorageItem(key) {
    if (localStorageAvailable) {
      try {
        window.localStorage.removeItem(key);
        return;
      } catch (error) {
        delete memoryStorage[key];
        return;
      }
    }

    delete memoryStorage[key];
  }

  function safeJsonParse(value, fallback) {
    if (!value || typeof value !== 'string') return clone(fallback);

    try {
      return JSON.parse(value);
    } catch (error) {
      return clone(fallback);
    }
  }

  function getJsonByteSize(value) {
    var serialized = typeof value === 'string' ? value : JSON.stringify(value);

    if (window.TextEncoder) {
      return new TextEncoder().encode(serialized).length;
    }

    return unescape(encodeURIComponent(serialized)).length;
  }

  function toStringValue(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim();
  }

  function createProductReference(input) {
    if (!input || typeof input !== 'object') return null;

    var handle = toStringValue(input.handle || input.productHandle || input.product_handle);
    if (!handle) return null;

    var productId = toStringValue(input.productId || input.product_id || input.id);
    var variantId = toStringValue(input.variantId || input.variant_id || input.selectedVariantId || input.selected_variant_id);
    var sku = toStringValue(input.sku || input.variantSku || input.variant_sku);
    var addedAt = Number(input.addedAt || input.added_at || now());

    return {
      type: 'product',
      handle: handle,
      productId: productId,
      variantId: variantId,
      sku: sku,
      addedAt: Number.isFinite(addedAt) ? addedAt : now()
    };
  }

  function createSceneReference(input) {
    if (!input || typeof input !== 'object') return null;

    var handle = toStringValue(input.handle || input.sceneHandle || input.scene_handle);
    if (!handle) return null;

    var addedAt = Number(input.addedAt || input.added_at || now());

    return {
      type: 'scene',
      handle: handle,
      title: toStringValue(input.title || input.sceneTitle || input.scene_title) || handle.replace(/-/g, ' '),
      url: toStringValue(input.url || input.sceneUrl || input.scene_url),
      image: toStringValue(input.image || input.imageUrl || input.image_url || input.sceneImage || input.scene_image),
      room: toStringValue(input.room || input.roomType || input.room_type),
      style: toStringValue(input.style || input.styleTags || input.style_tags),
      materials: toStringValue(input.materials || input.materialTags || input.material_tags),
      addedAt: Number.isFinite(addedAt) ? addedAt : now()
    };
  }

  function createReference(input) {
    if (!input || typeof input !== 'object') return null;
    var type = toStringValue(input.type || input.resourceType || input.resource_type || input.kind).toLowerCase();
    return type === 'scene' ? createSceneReference(input) : createProductReference(input);
  }

  function getReferenceType(reference) {
    return reference && reference.type === 'scene' ? 'scene' : 'product';
  }

  function getReferenceKey(reference) {
    var normalized = createReference(reference);
    if (!normalized) return '';
    if (normalized.type === 'scene') return 'scene:' + normalized.handle;
    if (normalized.variantId) return 'product:variant:' + normalized.variantId;
    if (normalized.productId) return 'product:id:' + normalized.productId;
    return 'product:handle:' + normalized.handle;
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return 'mcube-' + Math.random().toString(36).slice(2, 10) + '-' + now();
  }

  function createEmitter() {
    var listeners = new Set();

    return {
      subscribe: function (callback) {
        if (typeof callback !== 'function') return function () {};
        listeners.add(callback);
        return function unsubscribe() {
          listeners.delete(callback);
        };
      },
      emit: function (payload) {
        listeners.forEach(function (callback) {
          try {
            callback(payload);
          } catch (error) {
            console.error('[MCube] Listener error', error);
          }
        });
      }
    };
  }

  function dispatchDocumentEvent(name, detail) {
    document.dispatchEvent(
      new CustomEvent(name, {
        bubbles: true,
        detail: detail || {}
      })
    );
  }

  function createSessionProductCache() {
    var cache = new Map();

    return {
      get: function (handle) {
        return cache.get(handle) || null;
      },
      set: function (handle, value) {
        if (!handle) return;
        cache.set(handle, value);
      },
      has: function (handle) {
        return cache.has(handle);
      },
      clear: function () {
        cache.clear();
      }
    };
  }

  function readVersionedState(key, initialState) {
    var parsed = safeJsonParse(getStorageItem(key), initialState);

    if (!parsed || typeof parsed !== 'object') {
      return clone(initialState);
    }

    if (Number(parsed.version) !== STORAGE_VERSION) {
      return clone(initialState);
    }

    return Object.assign(clone(initialState), parsed);
  }

  function writeVersionedState(key, nextState) {
    var payload = Object.assign({}, clone(nextState), {
      version: STORAGE_VERSION,
      updatedAt: now()
    });

    setStorageItem(key, JSON.stringify(payload));
    return payload;
  }

  window.MCubeCore = {
    ACCOUNT_SYNC_CONFIG: clone(accountSyncConfig),
    FALLBACK_STORAGE_KEYS: FALLBACK_STORAGE_KEYS,
    LEGACY_STORAGE_KEYS: LEGACY_STORAGE_KEYS,
    STORAGE_KEYS: STORAGE_KEYS,
    STORAGE_VERSION: STORAGE_VERSION,
    clone: clone,
    createEmitter: createEmitter,
    createProductReference: createProductReference,
    createReference: createReference,
    createSceneReference: createSceneReference,
    createSessionProductCache: createSessionProductCache,
    dispatchDocumentEvent: dispatchDocumentEvent,
    getReferenceType: getReferenceType,
    getReferenceKey: getReferenceKey,
    getJsonByteSize: getJsonByteSize,
    getStorageItem: getStorageItem,
    hasLocalStorage: function () {
      return localStorageAvailable;
    },
    isAccountSyncActive: function () {
      return accountSyncActive;
    },
    now: now,
    readVersionedState: readVersionedState,
    removeStorageItem: removeStorageItem,
    safeJsonParse: safeJsonParse,
    setStorageItem: setStorageItem,
    toStringValue: toStringValue,
    uuid: uuid,
    writeVersionedState: writeVersionedState
  };
})();
